'use client';

import Image from 'next/image';

import { Trans } from '@kit/ui/trans';

export function MainNarrafixStudio() {
  return (
    <div
      className="scroll-mt-16 bg-gradient-to-r from-secondary to-primary pb-0 pt-16 md:from-primary md:to-secondary xl:pt-20"
      id="nfx-studio"
    >
      <div className={'container max-w-screen-lg'}>
        <div className="flex flex-col space-y-12">
          {/* Headline */}
          <h2 className="flex flex-wrap items-end justify-center gap-3 text-3.5xl text-white md:text-4xl lg:text-5xl">
            <span className="leading-0 font-heading">
              <Trans i18nKey={'marketing:sectionStudio:headlinePrefix'} />
            </span>
            <span className="flex translate-y-1 items-center gap-2">
              <Image
                src="/images/logo-narrafix-white.svg"
                alt="narrafix"
                width={300}
                height={63}
                className="h-[30px] w-auto -translate-y-[3px] md:inline md:h-[30px] lg:h-[39px]"
              />
              <span className="text-2xl tracking-wide text-stone-200 lg:text-3xl">
                STUDIO
              </span>
            </span>
          </h2>

          {/* Two columns text */}
          <div className="md grid grid-cols-1 gap-8 text-white md:grid-cols-2">
            <div className="text-lg md:text-xl">
              <Trans i18nKey={'marketing:sectionStudio:textLeft'} />
            </div>
            <div className="text-lg md:text-xl">
              <Trans i18nKey={'marketing:sectionStudio:textRight'} />
            </div>
          </div>

          {/* Image */}
          <div className="!mt-5 flex items-center justify-center align-middle md:!mt-0 lg:-translate-x-8">
            <Image
              src="/images/ScreenMockup_NNXStudio_NOSHADOW@2x.png"
              alt="Narrafix Studio Screenshot"
              width={2560}
              height={1600}
              className="max-w-full md:max-w-2xl"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
